import { React, useState } from "react";
import TopTitleBar from "./TopTitleBar";
import { Link } from "react-router-dom";
import Loader from "../../../components/Loader";
import { Icon } from 'react-icons-kit';
import { arrow_right } from 'react-icons-kit/ikons/arrow_right';
import SlideUpWrapper from "../../../components/Transitions/SlideUpWrapper";
import useRefreshToken from "../../../Hooks/usegenerateToken";

const BulkStatus = () => {
  useRefreshToken(BASE_URL + USER_TOKEN)
  const [loading, setLoading] = useState(false);
  return (
    <>
      <SlideUpWrapper>
        <TopTitleBar isChild>
          <h2 className="topTitleBarText">
            <Link className="text-decoration-none" to="/dashboard/credentials">
              Credentials
            </Link>
            <span className="text-decoration-none" onClick={e => handleStep(1)}> <Icon icon={arrow_right} /> Issue Crdentials</span>
            <span className="secondaryButton"> <Icon icon={arrow_right} /> Bulk Upload</span>
          </h2>
        </TopTitleBar >
        <form>
          <div className="bulkupload-container1">
            <div className="bulk-status">
              <div className="correct-bulk">
                <div>
                  <img src="/checkcircle.svg" style={{ width: "30px" }} />
                </div>
                <div>
                  <span style={{ color: "darkgreen" }}>July-Candidate.CSV</span>
                  <p style={{ color: "green" }}>200 KB-100% uploaded</p>
                </div>
              </div>
            </div>
            <div className="status-btn">
              <div className="btn5">
                <div>
                  <img
                    className="uploadOutlineIcon"
                    alt=""
                    src="/downloadUpload.svg"
                    style={{ width: "15px", paddingRight: "7px" }}
                  />
                </div>
                <div style={{ fontWeight: "500", padding: "1px" }}>
                  Download Bulk Template
                </div>
              </div>
              <div className="btn5">
                <div>
                  <img
                    className="uploadOutlineIcon"
                    alt=""
                    src="/uploadoutline.svg"
                    style={{ width: "15px", paddingRight: "7px" }}
                  />
                </div>
                <div style={{ fontWeight: "500", padding: "1px" }}>
                  Re-Upload Bulk List
                </div>
              </div>
            </div>
            <div className="btn6">
              Countinue
            </div>
          </div>
        </form>
      </SlideUpWrapper>
    </>
  );
};

export default BulkStatus;
